export default __webpack_public_path__ + "static/media/mahol.979b6df1.svg";